import { Controller, useFormContext } from "react-hook-form";
import InlineContainer from "../../common/InlineContainer";
import OutlineButton from "../../buttons/OutlineButton";
import { InputBaseParams } from "../Form";

export type ButtonOption<T extends string | number | boolean | undefined> = {
  value: T;
  label?: string;
  isDisabled?: boolean;
};

export const ButtonOptions = <T extends string | number | boolean | undefined>({
  value,
  options,
  error,
  className,
  onChange
}: {
  value?: T;
  options: ButtonOption<T>[];
  error?: boolean;
  className?: string;
  onChange: (value: T) => void;
}) => (
  <InlineContainer className="w-fit">
    {options.map((option, index) => (
      <OutlineButton
        key={index}
        className={
          className +
          " " +
          (value === option.value
            ? "!bg-ctb-blue-400 !text-white hover:!cursor-default"
            : error
            ? "border-ctb-red-500 text-ctb-red-500"
            : "")
        }
        onClick={() => onChange(option.value)}
        disabled={option?.isDisabled}
      >
        {option.label || option.value}
      </OutlineButton>
    ))}
  </InlineContainer>
);

const ControlledButtonOptions = <T extends string | number | boolean>({
  name,
  options,
  rules,
  className,
  onChangeCallback
}: InputBaseParams & {
  options: ButtonOption<T>[];
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { value, onChange }, fieldState: { error } }) => (
        <ButtonOptions
          value={value}
          options={options}
          error={error !== undefined}
          onChange={value => {
            onChangeCallback && onChangeCallback(value);
            onChange(value);
          }}

          className={className}
        />
      )}
    />
  );
};

export default ControlledButtonOptions;
